import { useState } from 'react'
import { DatePicker, Space } from 'antd'
import cn from 'classnames'
import moment, { Moment } from 'moment'
import { Button, BUTTON_TYPES } from 'components/Button'
import { TDropdownProps } from 'components/Dropdown/types'
import { RangeValue } from 'rc-picker/lib/interface'

import './datepicker.default.scss'
import {
  timelineDateFormat,
  timelineDateFormatShort,
  timelineDateShortFormat,
  timelineDateShortYearFormat,
  timelineShortMonthFullYearFormat
} from '../Timelines/constants'

const { RangePicker } = DatePicker

export const Filter = <FiltersType, ApplyFiltersFunc, SearchFuncType>({
  className,
  applyFilters,
  appliedFilters,
  confirm,
  field,
  rangeClassName,
  ...props
}: TDropdownProps<FiltersType, ApplyFiltersFunc, SearchFuncType>) => {
  const [selectedOptions, setSelectedOptions] = useState<RangeValue<Moment>>([
    moment(appliedFilters ? appliedFilters[0] : null),
    moment(appliedFilters ? appliedFilters[1] : null)
  ])

  const handleApplyFilters = () => {
    if (typeof applyFilters === 'function') {
      applyFilters(
        field,
        selectedOptions?.map((date) => date?.format('YYYY-MM-DD')).join(',')
      )
      confirm({ closeDropdown: true })
    }
  }

  return (
    <div className={cn('rangepicker-filter', className)}>
      <Space>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*@ts-ignore*/}
        <RangePicker
          format={[
            timelineDateFormat,
            timelineShortMonthFullYearFormat,
            timelineDateFormatShort,
            timelineDateShortFormat,
            timelineDateShortYearFormat
          ]}
          value={selectedOptions as RangeValue<Moment>}
          getPopupContainer={(trigger) =>
            trigger.parentElement ? trigger.parentElement : document.body
          }
          onChange={(dateStrings) => {
            setSelectedOptions(dateStrings)
          }}
          allowClear={true}
          {...props}
          className={rangeClassName}
        />
      </Space>
      <Space>
        <Button
          type={BUTTON_TYPES.DEFAULT}
          upperCase
          disabled={!selectedOptions?.length}
          onClick={() => setSelectedOptions(null)}
        >
          reset
        </Button>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          upperCase
          onClick={handleApplyFilters}
        >
          save
        </Button>
      </Space>
    </div>
  )
}
